/**
 * action types
 */
export const CANCEL_LOGIN = 'CANCEL_LOGIN';
export const CLEAR_RETRIES_QUEUE = 'CLEAR_RETRIES_QUEUE';
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const CANCEL_FORGOT_PASSWORD = 'CANCEL_FORGOT_PASSWORD';
export const LOGIN_REQUIRED = 'LOGIN_REQUIRED';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const FACEBOOK_LOGIN_START = 'FACEBOOK_LOGIN_START';
export const FACEBOOK_LOGIN_SUCCESS = 'FACEBOOK_LOGIN_SUCCESS';
export const FACEBOOK_LOGIN_FAILURE = 'FACEBOOK_LOGIN_FAILURE';
export const APPLE_LOGIN_START = 'APPLE_LOGIN_START';
export const APPLE_LOGIN_SUCCESS = 'APPLE_LOGIN_SUCCESS';
export const APPLE_LOGIN_FAILURE = 'APPLE_LOGIN_FAILURE';
export const MICROSOFT_LOGIN_START = 'MICROSOFT_LOGIN_START';
export const MICROSOFT_LOGIN_SUCCESS = 'MICROSOFT_LOGIN_SUCCESS';
export const MICROSOFT_LOGIN_FAILURE = 'MICROSOFT_LOGIN_FAILURE';
export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const LOGOUT_COMPLETED = 'LOGOUT_COMPLETED';
export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_ACCESS = 'SET_CURRENT_USER_ACCESS';
export const SET_IN_PROGRESS_FALSE = 'SET_IN_PROGRESS_FALSE';
export const SIGNUP_START = 'SIGNUP_START';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';
export const AUTH_SET_CURRENT_PORTAL_NAME = 'AUTH_SET_CURRENT_PORTAL_NAME';
export const AUTH_SET_CURRENT_COURSE = 'AUTH_SET_CURRENT_COURSE';
export const AUTH_SET_CURRENT_COHORT = 'AUTH_SET_CURRENT_COHORT';
export const START_FETCH_ENROLLED_CLASS_DATA =
  'START_FETCH_ENROLLED_CLASS_DATA';
export const UPDATE_ENROLLED_CLASS_DATA = 'UPDATE_ENROLLED_CLASS_DATA';
export const SET_ENROLMENTS_HISTORY = 'SET_ENROLMENTS_HISTORY';
export const SET_LEGACY_TOKEN = 'SET_LEGACY_TOKEN';
export const SET_SUBDOMAIN_COOKIE = 'SET_SUBDOMAIN_COOKIE';
export const SIGNUP_USER_REQUIRED = 'SIGNUP_USER_REQUIRED';
export const CURRENT_SSO_USER_DETAILS = 'CURRENT_SSO_USER_DETAILS';
export const SSO_USER_CONTEXT = 'SSO_USER_CONTEXT';
export const SET_LOGIN_DATE = 'SET_LOGIN_DATE';
export const SET_LOGIN_MODE = 'SET_LOGIN_MODE';
export const TOKEN_REFRESHED = 'TOKEN_REFRESHED';
export const START_FETCH_SIMPLE_ENROLLED_CLASS_DATA =
  'START_FETCH_SIMPLE_ENROLLED_CLASS_DATA';
export const UPDATE_SIMPLE_ENROLLED_CLASS_DATA =
  'UPDATE_SIMPLE_ENROLLED_CLASS_DATA';
